module.exports = __webpack_public_path__ + "static/media/welcome.66a41fd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/welcome.png
// module id = 189
// module chunks = 0